<div
  class="animated fadeIn faster fixed inset-0 top-0 left-0 z-50 flex h-screen min-w-screen items-center justify-center bg-cover bg-center bg-no-repeat outline-none focus:outline-none"
  id="modal-id"
>
  <div class="absolute inset-0 z-0 bg-black opacity-30"></div>
  <div class="bg-lightGrayish relative m-auto w-full max-w-lg rounded-xl p-5 shadow-lg">
    <div class="flex flex-col items-center p-5 text-center" data-cy="confirm-dialog">
      <img class="h-8" src="assets/img/icons/{{ data.image }}.png" alt="delete" />
      <h2 class="py-4 text-xl">{{ data.headline }}</h2>
      <p class="grayText px-8 text-sm">{{ data.text }}</p>

      <!-- Loading spinner when publishing -->
      @if (data.isLoading) {
        <div class="flex flex-col items-center justify-center py-4">
          <div class="border-sunflowerGold h-8 w-8 animate-spin rounded-full border-4 border-t-transparent"></div>
        </div>
      } @else {
        <div
          [ngClass]="data.arrayType !== 'suggestion' ? 'flex-row-reverse justify-between' : ''"
          class="flex w-full items-center"
        >
          <div
            [ngClass]="{ 'w-full': data.arrayType === 'suggestion' }"
            class="mt-2 flex items-center space-x-4 p-3 text-center"
          >
            @if (data.arrayType === 'suggestion') {
              <button
                (click)="onSubmit('true')"
                class="bg-almostBlack text-sunflowerGold mb-2 flex h-9 items-center justify-center border border-black px-5 py-2.5 text-center text-sm font-medium tracking-wider shadow-sm hover:bg-black hover:shadow-lg focus:ring-4 focus:outline-none sm:w-auto md:mb-0"
              >
                Buy!
              </button>
            }
            <button
              [ngClass]="{
                'border-gray-200 bg-white !text-red-500 hover:bg-gray-100 hover:shadow-lg':
                  data.arrayType === 'suggestion',
              }"
              (click)="onSubmit('false')"
              class="bg-almostBlack text-sunflowerGold mb-2 flex h-9 items-center justify-center border border-black px-5 py-2.5 text-center text-sm font-medium tracking-wider shadow-sm hover:bg-black hover:shadow-lg focus:ring-4 focus:outline-none sm:w-auto md:mb-0"
              data-cy="modal-confirm-button"
            >
              {{ data.arrayType === 'suggestion' ? 'Delete' : 'Yes!' }}
            </button>
          </div>
          <div class="mt-2 flex justify-center space-x-4 p-3 text-center">
            <button
              (click)="onClose()"
              class="grayText mb-2 flex h-9 items-center border bg-white px-5 py-2 text-sm font-medium tracking-wider shadow-sm hover:bg-gray-100 hover:shadow-lg md:mb-0"
              data-cy="pi-reject-del-button"
            >
              Cancel
            </button>
          </div>
        </div>
      }
    </div>
  </div>
</div>
